import React, { FC } from 'react';
import { AssessmentPortalApp } from '../assessment-portal';
import { adhdPortalConfig } from './config';

const AdhdPortalApp: FC = () => (
  <AssessmentPortalApp config={adhdPortalConfig} />
);

export default AdhdPortalApp;
